import { isCurrencyEqual } from "../../../utils";
import { MonetaryAmount } from "@interlay/monetary-js";
import Big from "big.js";
import { MultiPathElementType } from "../trade/types";
import { PoolType } from "../types";
import { LiquidityPoolCalculator } from "./calculator";
class StandardLiquidityPool extends LiquidityPoolCalculator {
    constructor(lpToken, pooledCurrencies, rewardAmountsYearly, tradingFee, isTradingActive, // True if in `Trading` state, false if in `Bootstrap` state
    totalSupply, isEmpty) {
        super(pooledCurrencies, totalSupply);
        this.lpToken = lpToken;
        this.pooledCurrencies = pooledCurrencies;
        this.rewardAmountsYearly = rewardAmountsYearly;
        this.tradingFee = tradingFee;
        this.isTradingActive = isTradingActive;
        this.totalSupply = totalSupply;
        this.isEmpty = isEmpty;
        this.type = PoolType.STANDARD;
        if (pooledCurrencies.length !== 2) {
            throw new Error("Standard liquidity pool has to always consist of 2 currencies!");
        }
        this.token0 = pooledCurrencies[0].currency;
        this.token1 = pooledCurrencies[1].currency;
        this.reserve0 = pooledCurrencies[0];
        this.reserve1 = pooledCurrencies[1];
    }
    pathOf(inputCurrency) {
        return {
            type: MultiPathElementType.STANDARD,
            input: inputCurrency,
            output: isCurrencyEqual(inputCurrency, this.token0) ? this.token1 : this.token0,
            pair: this,
            pool: this,
        };
    }
    /**
     * Get output amount of pool after swap of `inputAmount` is made.
     *
     * @param {MonetaryAmount<CurrencyExt>} inputAmount Input amount of currency to swap.
     * @returns {MonetaryAmount<CurrencyExt>} Output amount after swap of `inputAmount` is made.
     */
    getOutputAmount(inputAmount) {
        let inputReserve;
        let outputReserve;
        let outputCurrency;
        if (isCurrencyEqual(inputAmount.currency, this.token0)) {
            [inputReserve, outputReserve, outputCurrency] = [this.reserve0, this.reserve1, this.token1];
        }
        else if (isCurrencyEqual(inputAmount.currency, this.token1)) {
            [inputReserve, outputReserve, outputCurrency] = [this.reserve1, this.reserve0, this.token0];
        }
        else {
            throw new Error(`StandardLiquidityPool: getOutputAmount: input currency ${inputAmount.currency.name} is not part of the pool.`);
        }
        if (this.reserve0.isZero() || this.reserve1.isZero()) {
            return new MonetaryAmount(outputCurrency, 0);
        }
        const inputAmountAfterTradingFee = inputAmount.toBig().mul(Big(1).sub(this.tradingFee));
        const numerator = inputAmountAfterTradingFee.mul(outputReserve.toBig());
        const denominator = inputReserve.toBig().add(inputAmountAfterTradingFee);
        const outputAmount = numerator.div(denominator);
        return new MonetaryAmount(outputCurrency, outputAmount);
    }
}
export { StandardLiquidityPool };
//# sourceMappingURL=standard.js.map